import { createFileRoute } from '@tanstack/react-router';

import { ResetPasswordPage } from '../components/auth/reset-password-page.tsx';

function validateResetPasswordSearch(search: Record<string, unknown>) {
	return {
		redirectTo: typeof search.redirectTo === 'string' ? search.redirectTo : undefined,
	};
}

export const Route = createFileRoute('/reset-password')({
	component: RootResetPasswordPage,
	validateSearch: validateResetPasswordSearch,
});

function RootResetPasswordPage() {
	const { redirectTo } = Route.useSearch();

	return <ResetPasswordPage redirectTo={redirectTo} />;
}
